import React, { useEffect, useState } from 'react';
import styles from './PlaceOrder.module.css';

import { InfoTooltip, StopSummaryTooltip } from './common';
import { buildDropOffSummary } from './stopSummary';
import { toLocation, useAddressAutocomplete } from './addressAutocomplete';

import closeIcon from "../../images/place_order/close-icon.png";

export function GuestStop(props) {
  const { currIdx, stop, active, showThread, totalStops, onAddressChange, onOpenDetails, onRemove, onMove, onError } = props;

  const [sequenceValue, setSequenceValue] = useState(currIdx + 1);

  useEffect(() => {
    setSequenceValue(currIdx + 1);
  }, [currIdx]);

  useAddressAutocomplete(`dropOffAutocomplete-${currIdx}`, (place) => {
    try {
      onAddressChange(currIdx, toLocation(place));
    } catch (error) {
      onError(true, "Please select a drop-off address from the drop-down list.");
    }
  });

  const commitSequence = () => {
    const newPosition = parseInt(sequenceValue, 10);

    if (isNaN(newPosition) || newPosition < 1 || newPosition > totalStops) {
      setSequenceValue(currIdx + 1);
      return;
    }

    if (newPosition - 1 !== currIdx) {
      onMove(currIdx, newPosition - 1);
    }
  }

  const hasDetails = Boolean(stop.recipientName);

  return (
    <div className={`${styles.poStop} ${active ? styles.poStopActive : ""}`}>
      <div className={styles.poRail}>
        <div className={`${styles.poPin} ${styles.poPinDropOff}`}>{currIdx + 1}</div>
        {showThread && <div className={styles.poThread} />}
      </div>

      <div className={styles.poStopMain}>
        <input
          className={styles.poAddrInput}
          id={`dropOffAutocomplete-${currIdx}`}
          name="dropOffAddress"
          value={stop.dropOffLocation.address}
          onChange={(e) => onAddressChange(currIdx, { address: e.target.value })}
          placeholder="Drop-off location"
          autoComplete="off"
        />

        <div id={`editDetails-${currIdx}`} className={styles.poMeta} onClick={() => onOpenDetails(currIdx)}>
          {
            hasDetails
              ? <>
                <span id={`detailsString-${currIdx}`} className={styles.poMetaText}>
                  {stop.recipientName}&nbsp;&nbsp;·&nbsp;&nbsp;{stop.recipientPhone}
                  {stop.dropOffLocation.unitNumber ? `  ·  ${stop.dropOffLocation.unitNumber}` : ""}
                </span>
                {stop.isCodEnabled && stop.codAmount > 0 && <span className={`${styles.poChip} ${styles.poChipCod}`}>COD RM {(stop.codAmount / 100).toFixed(2)}</span>}
                {stop.deliveryFee > 0 && <span className={styles.poChip}>RM {(stop.deliveryFee / 100).toFixed(2)}</span>}
              </>
              : <span id={`enterDetails-${currIdx}`} className={styles.poMissing}>
                <i className="fas fa-exclamation-circle" style={{ fontSize: 12 }} />
                Add contact details
              </span>
          }
          <StopSummaryTooltip rows={buildDropOffSummary(stop, "RM")} />
        </div>
      </div>

      <div className={styles.poStopActs}>
        <InfoTooltip title="Type a position to move this stop, or drag the handle." placement="top" arrow>
          <input
            id={`sequenceInput-${currIdx}`}
            className={styles.poSeqInput}
            type="number"
            min={1}
            max={totalStops}
            value={sequenceValue}
            onChange={(e) => setSequenceValue(e.target.value)}
            onBlur={commitSequence}
            onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
          />
        </InfoTooltip>
        <InfoTooltip title="Remove this stop" placement="top" arrow>
          <button id={`deleteIcon-${currIdx}`} className={styles.poIco} onClick={() => onRemove(currIdx)}>
            <img src={closeIcon} alt="remove" />
          </button>
        </InfoTooltip>
      </div>
    </div>
  )
}
